<template>
  <div class='h-dialogContainer h-alarm-filter'>
    <form id='addIndicatorThresholdForm'>
      <div class="row h-row-inputBox">
        <div class="col-sm-6 h-col-inputBox">
          <div class="h-inputLit"><span class="h-red-code">* </span>{{$t('Topo.neType')}}:</div>
          <div class="e-input-group e-control-wrapper">
            <ejs-dropdownlist id='neTypeList' :dataSource='dataSourceOfNeType' :fields='fieldsOfNeType' v-model="neType"></ejs-dropdownlist>
          </div>
        </div>
        <div class="col-sm-6 h-col-inputBox">
          <div class="h-inputLit"><span class="h-red-code">* </span>{{$t('Pm.indicator')}}:</div>
          <div class="e-input-group e-control-wrapper">
            <ejs-dropdownlist id='indicator' :readonly='allowEdit' :dataSource='dataSourceOfIndicator.list' :fields='dataSourceOfIndicator.listFields' v-model="dataSourceOfIndicator.checkValue"></ejs-dropdownlist>
          </div>
        </div>
      </div>
      <div class="row h-row-inputBox">
        <div class="col-sm-6 h-col-inputBox">
          <div class="h-inputLit"><span class="h-red-code">* </span>{{$t('Alarm.upperLimitOfTheBusyTimeThreshold')}}:</div>
          <div class="e-input-group e-control-wrapper">
            <ejs-textbox  name="upperLimitOfTheBusyTimeThreshold" v-model="upperLimitOfTheBusyTimeThreshold"></ejs-textbox>
          </div>
          <div class="error-message" id="upperLimitOfTheBusyTimeThresholdError"></div>
        </div>
        <div class="col-sm-6 h-col-inputBox">
          <div class="h-inputLit"><span class="h-red-code">* </span>{{$t('Alarm.lowerLimitOfTheBusyTimeThreshold')}}:</div>
          <div class="e-input-group e-control-wrapper">
            <ejs-textbox  name="lowerLimitOfTheBusyTimeThreshold" v-model="lowerLimitOfTheBusyTimeThreshold"></ejs-textbox>
          </div>
          <div class="error-message" id="lowerLimitOfTheBusyTimeThresholdError"></div>
        </div>
      </div>
      <div class="row h-row-inputBox">
        <div class="col-sm-6 h-col-inputBox">
          <div class="h-inputLit"><span class="h-red-code">* </span>{{$t('Alarm.upperLimitOfTheIdelTimeThreshold')}}:</div>
          <div class="e-input-group e-control-wrapper">
            <ejs-textbox  name="upperLimitOfTheIdelTimeThreshold" v-model="upperLimitOfTheIdelTimeThreshold"></ejs-textbox>
          </div>
          <div class="error-message" id="upperLimitOfTheIdelTimeThresholdError"></div>
        </div>
        <div class="col-sm-6 h-col-inputBox">
          <div class="h-inputLit"><span class="h-red-code">* </span>{{$t('Alarm.lowerLimitOfTheIdelTimeThreshold')}}:</div>
          <div class="e-input-group e-control-wrapper">
            <ejs-textbox  name="lowerLimitOfTheIdelTimeThreshold" v-model="lowerLimitOfTheIdelTimeThreshold"></ejs-textbox>
          </div>
          <div class="error-message" id="lowerLimitOfTheIdelTimeThresholdError"></div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>

import {EventBus} from "@/plugins/eventBus";
import {FormValidator} from "@syncfusion/ej2-vue-inputs";

const pattern = /^\d+$/;
export default {
  name: "addIdelTimeIndicatorThreshold",
  data() {
    return {
      id: "",
      allowEdit: false,
      dataSourceOfNeType: [],
      dataSourceOfIndicator: {
        listFields: { text: 'name', value: 'value' },
        list: [
          { name: this.$t('Alarm.K0000020030'), value: 'K0000020030' },
          { name: this.$t('Alarm.K0000020031'), value: 'K0000020031' },
          { name: this.$t('Alarm.K0000020032'), value: 'K0000020032' },
          { name: this.$t('Alarm.K0000020052'), value: 'K0000020052' },
          { name: this.$t('Alarm.K0000020062'), value: 'K0000020062' },
          { name: this.$t('Alarm.K0000020051'), value: 'K0000020051' },
          { name: this.$t('Alarm.K0000020092'), value: 'K0000020092' },
          { name: this.$t('Alarm.K0000020093'), value: 'K0000020093' },
          { name: this.$t('Alarm.K0000020074'), value: 'K0000020074' },
          { name: this.$t('Alarm.K0000020174'), value: 'K0000020174' },
          { name: this.$t('Alarm.K0000020175'), value: 'K0000020175' },
          { name: this.$t('Alarm.K0000020180'), value: 'K0000020180' },
          { name: this.$t('Alarm.K0000020181'), value: 'K0000020181' },
          { name: this.$t('Alarm.K0000020172'), value: 'K0000020172' },
          { name: this.$t('Alarm.K0000020173'), value: 'K0000020173' },
          { name: this.$t('Alarm.K0000020178'), value: 'K0000020178' },
          { name: this.$t('Alarm.K0000020179'), value: 'K0000020179' },
          { name: this.$t('Alarm.K0000020170'), value: 'K0000020170' },
          { name: this.$t('Alarm.K0000020171'), value: 'K0000020171' },
          { name: this.$t('Alarm.K0000020176'), value: 'K0000020176' },
          { name: this.$t('Alarm.K0000020177'), value: 'K0000020177' },
        ],
        checkValue: 'K0000020030'
      },
      upperLimitOfTheIdelTimeThreshold: "",
      lowerLimitOfTheIdelTimeThreshold: "",
      upperLimitOfTheBusyTimeThreshold: "",
      lowerLimitOfTheBusyTimeThreshold: "",
      dateFormat: 'HH:mm:ss',
      neType: '101',
      fieldsOfNeType: {
        text: 'neTypeCode',
        value: 'neTypeId'
      },
      validationOption: {
        customPlacement(inputElement, errorElement) {
          errorElement.style.position = 'left';
          inputElement.parentElement.parentElement.appendChild(errorElement);
        },
        rules: {}
      }
    }
  },
  mounted() {
    this.init();
    this.bindValidate();
  },
  methods: {
    init() {
      this.$axios.get('/lte/pm/measuretaskmanagement/getNeTypeByNeTypeId.html?neTypeId=101').then((response) => {
        this.dataSourceOfNeType = response.data.resultVal;
        this.neType = response.data.resultVal[0].neTypeId;
      });
    },
    getIndicatorThresholdData() {
      let elementUpperIdelTime = document.getElementById('upperLimitOfTheIdelTimeThresholdError');
      let elementLowerIdelTime = document.getElementById('lowerLimitOfTheIdelTimeThresholdError');
      let elementUpperBusyTime = document.getElementById('upperLimitOfTheBusyTimeThresholdError');
      let elementLowerBusyTime = document.getElementById('lowerLimitOfTheBusyTimeThresholdError');

      if (elementUpperIdelTime.innerHTML !== '' || elementLowerIdelTime.innerHTML !== '' || elementUpperBusyTime.innerHTML !== '' || elementLowerBusyTime.innerHTML !== '') {
        return false;
      }
      if (this.upperLimitOfTheBusyTimeThreshold === '') {
        elementUpperBusyTime.innerHTML = `<span style='color:red;font-size: 12px;display: inline-block;height: 22px;line-height: 22px;' >${this.$t('MML.notNull')}</span>`;
        return false;
      }
      if (this.lowerLimitOfTheBusyTimeThreshold === '') {
        elementLowerBusyTime.innerHTML = `<span style='color:red;font-size: 12px;display: inline-block;height: 22px;line-height: 22px;' >${this.$t('MML.notNull')}</span>`;
        return false;
      }
      if (this.upperLimitOfTheIdelTimeThreshold === '') {
        elementUpperIdelTime.innerHTML = `<span style='color:red;font-size: 12px;display: inline-block;height: 22px;line-height: 22px;' >${this.$t('MML.notNull')}</span>`;
        return false;
      }
      if (this.lowerLimitOfTheIdelTimeThreshold === '') {
        elementLowerIdelTime.innerHTML = `<span style='color:red;font-size: 12px;display: inline-block;height: 22px;line-height: 22px;' >${this.$t('MML.notNull')}</span>`;
        return false;
      }

      return {
        id: this.id,
        neTypeId: this.neType,
        counterCode: this.dataSourceOfIndicator.checkValue,
        upperLimitOfTheIdelTimeThreshold: this.upperLimitOfTheIdelTimeThreshold,
        lowerLimitOfTheIdelTimeThreshold: this.lowerLimitOfTheIdelTimeThreshold,
        upperLimitOfTheBusyTimeThreshold: this.upperLimitOfTheBusyTimeThreshold,
        lowerLimitOfTheBusyTimeThreshold: this.lowerLimitOfTheBusyTimeThreshold,
      }
    },
    bindValidate() {
      this.formObj = new FormValidator('#addIndicatorThresholdForm', this.validationOption);
    },
    validate() {
      const formStatus = this.formObj.validate();
      return formStatus;
    },
    setParams(info) {
      this.clearData();
      this.id = info.id;
      this.upperLimitOfTheIdelTimeThreshold = info.upperLimitOfTheIdelTimeThreshold;
      this.lowerLimitOfTheIdelTimeThreshold = info.lowerLimitOfTheIdelTimeThreshold;
      this.upperLimitOfTheBusyTimeThreshold = info.upperLimitOfTheBusyTimeThreshold;
      this.lowerLimitOfTheBusyTimeThreshold = info.lowerLimitOfTheBusyTimeThreshold;
    },
    clearData() {
      this.bindValidate();
      this.upperLimitOfTheIdelTimeThreshold = "";
      this.lowerLimitOfTheIdelTimeThreshold = "";
      this.upperLimitOfTheBusyTimeThreshold = "";
      this.lowerLimitOfTheBusyTimeThreshold = "";
      const errorDom = document.querySelectorAll('label.e-error');
      for (let i = 0; i < errorDom.length; i++) {
        errorDom[i].innerHTML = '';
      }
    },
  },
  watch: {
    //针对【闲时】上下限做校验，要求：下限值不应能够高于上限值 或者 上限值不应能够低于下限值，否则就下方错误提示
    upperLimitOfTheIdelTimeThreshold: {
      immediate:true,
      handler(newValue,oldValue){
        let elementUpper = document.getElementById('upperLimitOfTheIdelTimeThresholdError');

        if (elementUpper && (newValue === '' || newValue === null || newValue === undefined) && this.upperLimitOfTheIdelTimeThreshold === '') {
          elementUpper.innerHTML = `<span style='color:red;font-size: 12px;display: inline-block;height: 22px;line-height: 22px;' >${this.$t('MML.notNull')}</span>`;
        } else if (elementUpper && newValue !== '' && !pattern.test(newValue)) {
          elementUpper.innerHTML = `<span style='color:red;font-size: 12px;display: inline-block;height: 22px;line-height: 22px;' >${this.$t('Alarm.notInteger')}</span>`;
        } else if (elementUpper && newValue !== '' && newValue > 100) {
          elementUpper.innerHTML = `<span style='color:red;font-size: 12px;display: inline-block;height: 22px;line-height: 22px;' >${this.$t('Alarm.maxValueIs')}100</span>`;
        } else if (newValue != '' && this.lowerLimitOfTheIdelTimeThreshold != '' && parseInt(newValue) <= parseInt(this.lowerLimitOfTheIdelTimeThreshold)) {
          elementUpper.innerHTML = `<span style='color:red;font-size: 12px;display: inline-block;height: 22px;line-height: 22px;' >${this.$t('Alarm.theLowerLimitValueShouldNotBeHigherThanTheUpperLimitValue')}</span>`;
        } else if (elementUpper  && newValue !== '' && newValue >= 0) {
          elementUpper.innerHTML = '';
        }
      }
    },
    lowerLimitOfTheIdelTimeThreshold: {
      immediate:true,
      handler(newValue,oldValue){
        let elementLower = document.getElementById('lowerLimitOfTheIdelTimeThresholdError');


        if (elementLower && (newValue === '' || newValue === null || newValue === undefined)) {
          elementLower.innerHTML = `<span style='color:red;font-size: 12px;display: inline-block;height: 22px;line-height: 22px;' >${this.$t('MML.notNull')}</span>`;
        } else if (elementLower && newValue !== '' && !pattern.test(newValue)) {
          elementLower.innerHTML = `<span style='color:red;font-size: 12px;display: inline-block;height: 22px;line-height: 22px;' >${this.$t('Alarm.notInteger')}</span>`;
        } else if (elementLower && newValue !== '' && newValue > 100) {
          elementLower.innerHTML = `<span style='color:red;font-size: 12px;display: inline-block;height: 22px;line-height: 22px;' >${this.$t('Alarm.maxValueIs')}100</span>`;
        } else if (newValue != '' && this.upperLimitOfTheIdelTimeThreshold != '' && parseInt(newValue) >= parseInt(this.upperLimitOfTheIdelTimeThreshold)) {
          elementLower.innerHTML = `<span style='color:red;font-size: 12px;display: inline-block;height: 22px;line-height: 22px;' >${this.$t('Alarm.theLowerLimitValueShouldNotBeHigherThanTheUpperLimitValue')}</span>`;
        } else if (elementLower && newValue !== '' && newValue >= 0) {
          elementLower.innerHTML = '';
        }
      }
    },
    //针对【闲时】上下限做校验，要求：下限值不应能够高于上限值 或者 上限值不应能够低于下限值，否则就下方错误提示
    upperLimitOfTheBusyTimeThreshold: {
      immediate:true,
      handler(newValue,oldValue){
        let elementUpper = document.getElementById('upperLimitOfTheBusyTimeThresholdError');

        if (elementUpper && (newValue === '' || newValue === null || newValue === undefined)) {
          elementUpper.innerHTML = `<span style='color:red;font-size: 12px;display: inline-block;height: 22px;line-height: 22px;' >${this.$t('MML.notNull')}</span>`;
        } else if (elementUpper && newValue !== '' && !pattern.test(newValue)) {
          elementUpper.innerHTML = `<span style='color:red;font-size: 12px;display: inline-block;height: 22px;line-height: 22px;' >${this.$t('Alarm.notInteger')}</span>`;
        } else if (elementUpper && newValue !== '' && newValue > 100) {
          elementUpper.innerHTML = `<span style='color:red;font-size: 12px;display: inline-block;height: 22px;line-height: 22px;' >${this.$t('Alarm.maxValueIs')}100</span>`;
        } else if (this.lowerLimitOfTheBusyTimeThreshold != '' && parseInt(newValue) <= parseInt(this.lowerLimitOfTheBusyTimeThreshold)) {
          elementUpper.innerHTML = `<span style='color:red;font-size: 12px;display: inline-block;height: 22px;line-height: 22px;' >${this.$t('Alarm.theLowerLimitValueShouldNotBeHigherThanTheUpperLimitValue')}</span>`;
        } else if (elementUpper && newValue !== '' && newValue >= 0) {
          elementUpper.innerHTML = '';
        }
      }
    },
    lowerLimitOfTheBusyTimeThreshold: {
      immediate:true,
      handler(newValue,oldValue){
        let elementLower = document.getElementById('lowerLimitOfTheBusyTimeThresholdError');

        if (elementLower && (newValue === '' || newValue === null || newValue === undefined)) {
          elementLower.innerHTML = `<span style='color:red;font-size: 12px;display: inline-block;height: 22px;line-height: 22px;' >${this.$t('MML.notNull')}</span>`;
        } else if (elementLower && newValue !== '' && !pattern.test(newValue)) {
          elementLower.innerHTML = `<span style='color:red;font-size: 12px;display: inline-block;height: 22px;line-height: 22px;' >${this.$t('Alarm.notInteger')}</span>`;
        } else if (elementLower && newValue !== '' && newValue > 100) {
          elementLower.innerHTML = `<span style='color:red;font-size: 12px;display: inline-block;height: 22px;line-height: 22px;' >${this.$t('Alarm.maxValueIs')}100</span>`;
        } else if (this.upperLimitOfTheBusyTimeThreshold != '' && parseInt(newValue) >= parseInt(this.upperLimitOfTheBusyTimeThreshold)) {
          elementLower.innerHTML = `<span style='color:red;font-size: 12px;display: inline-block;height: 22px;line-height: 22px;' >${this.$t('Alarm.theLowerLimitValueShouldNotBeHigherThanTheUpperLimitValue')}</span>`;
        } else if (elementLower && newValue !== '' && newValue >= 0) {
          elementLower.innerHTML = '';
        }
      }
    },
  }
}
</script>

<style scoped>
</style>
